const scrollToCoordinates = (x, y) => {
  window.scrollTo({
    left: x,
    top: y,
    behavior: 'smooth',
  });
};

export default scrollToCoordinates;
